'use strict';

(function () {
  'use strict';

  angular.module('msAssessment').provider('assessmentRouter', assessmentRouterProvider);

  /* @ngInject */
  function assessmentRouterProvider() {
    var provider = this;
    provider.$get = ['errorRouter', 'authenticationRouter', assessmentRouterFactory];
    provider.buildRoutes = _buildRoutes;
    provider.setContext = _setContext;

    function assessmentRouterFactory(errorRouter, authenticationRouter) {
      var factory = this;
      factory.router = {
        navigateEntry: _navigateEntry,
        navigateNextQuestion: _navigateNextQuestion,
        navigateDisclaimer: _navigateDisclaimer,
        navigateError: errorRouter.navigateError,
        navigate404: errorRouter.navigate404,
        goToState: authenticationRouter.goToState,
        goToNextStep: authenticationRouter.goToNextStep
      };
      return factory.router;

      function _navigateEntry(args, overlay) {
        authenticationRouter.goToState('^.notice', args, overlay);
      }

      function _navigateNextQuestion(args) {
        authenticationRouter.goToState('^.questionChild', args);
      }

      function _navigateDisclaimer(args) {
        authenticationRouter.goToState('^.disclaimer', args);
      }
    }

    function _setContext(context) {
      provider.context = context;
    }

    function _buildAssessmentBaseRoute() {
      return {
        name: 'steps.assessment',
        url: 'assessment?types',
        data: {
          pageTitle: 'pageTitles.assessments'
        },
        abstract: true,
        template: '<div class="ani-wrapper">\n                     <ui-view class="assessment-view"></ui-view>\n                   </div>'
      };
    }

    function _buildAssessmentDisclaimerRoute() {
      return {
        name: 'steps.assessment.disclaimer',
        url: '/disclaimer',
        template: '<ms-assessment-disclaimer  is-component="false" provider-context="$resolve.providerContext"></ms-assessment-disclaimer>',
        controller: 'DisclaimerCtrl',
        controllerAs: 'vm',
        resolve: {
          providerContext: [function () {
            return provider.context;
          }]
        }
      };
    }

    function _buildAssessmentQuestionRoute() {
      return {
        name: 'steps.assessment.question',
        url: '/:assessment',
        templateUrl: 'assessments/templates/assessment.html',
        controllerAs: 'vm',
        controller: 'AssessmentCtrl',
        resolve: {
          providerContext: [function () {
            return provider.context;
          }]
        },
        params: {
          assessment: null
        }
      };
    }

    function _buildAssessmentQuestionRouteChild() {
      return {
        name: 'steps.assessment.question.questionChild',
        url: '/:question',
        template: '<ms-assessment-question\n                      question-index="questionVm.currentQuestionIndex"\n                      assessment="vm.assessment"\n                      translate-prefix="vm.translatePrefix"\n                      ng-if="vm.assessment"\n                      select-fn="vm.next") >\n                   </ms-assessment-question>',
        params: {
          question: null
        },
        controllerAs: 'questionVm',
        controller: ['$stateParams', function ($stateParams) {
          this.currentQuestionIndex = $stateParams.question;
        }]
      };
    }

    function _buildAssessmentEntryRoute() {
      return {
        name: 'steps.assessment.notice',
        url: '',
        templateUrl: 'assessments/templates/assessmentNotice.html',
        controllerAs: 'vm',
        controller: 'AssessmentNoticeCtrl',
        resolve: {
          providerContext: [function () {
            return provider.context;
          }]
        }
      };
    }

    function _buildRoutes() {
      var base = _buildAssessmentBaseRoute();
      var entry = _buildAssessmentEntryRoute();
      var questions = _buildAssessmentQuestionRoute();
      var questionChild = _buildAssessmentQuestionRouteChild();
      var disclaimer = _buildAssessmentDisclaimerRoute();
      return [base, entry, disclaimer, questions, questionChild];
    }
  }
})();